import { z } from 'zod';
import { defaultResponse } from '@/lib/generate-rules';
import { toTypedSchema } from '@vee-validate/zod';

export const numericAboveZero = toTypedSchema(
  z.preprocess(
    (val) => {
      if (val === '') return undefined; // treat empty string as missing
      if (typeof val === 'string') {
        const num = Number(val);
        return isNaN(num) ? val : num; // convert if valid number
      }
      return val; // keep numbers as is
    },
    z
      .number({ required_error: defaultResponse, invalid_type_error: 'Must be a number' })
      .int('Only whole numbers are allowed') // This is the key message for decimals
      .min(0, 'Must be greater than or equal to 0')
  )
);
